import { CheckCircle2, X, XCircle } from 'lucide-react'

export type ToastState = {
  type: 'success' | 'error'
  message: string
} | null

export function Toast({ toast, onClose }: { toast: ToastState; onClose: () => void }) {
  if (!toast) return null
  const Icon = toast.type === 'success' ? CheckCircle2 : XCircle
  return (
    <div className={`toast toast--${toast.type}`} role="status">
      <Icon size={20} />
      <span>{toast.message}</span>
      <button onClick={onClose} aria-label="Fechar"><X size={17} /></button>
    </div>
  )
}
